import React from "react";
import { SocialIcon } from 'react-social-icons';


export default function Footer() {
  return (
    <>
      <footer className="relative bg-blueGray-200 pt-8 pb-6">
        <div
          className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
          style={{ transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-blueGray-200 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap text-center lg:text-left">
            <div className="w-full lg:w-6/12 px-4">
              <h4 className="text-3xl font-semibold">Let's keep in touch!</h4>
              <h5 className="text-lg mt-0 mb-2 text-blueGray-600">
                Find us on any of these platforms, we'll respond in 1-2 business days.
              </h5>
              <div className="flex gap-2 mt-6 md:justify-start md:mb-0 mb-8 justify-center">
                            <SocialIcon target="blank" url="https://twitter.com/ZippyOps" network="twitter" fgColor="#fff" style={{ height: 35, width: 35 }} />
                            <SocialIcon target="blank" url="https://facebook.com/zippyops" network="facebook" fgColor="#fff" style={{ marginLeft: '1em', height: 35, width: 35 }} />
                            <SocialIcon target="blank" url="https://instagram.com/zippyops" network="instagram" fgColor="#fff" style={{ marginLeft: '1em', height: 35, width: 35 }} />
                            <SocialIcon target="blank" url="https://youtube.com/channel/UCZh2aijMM-h6ztRo36m3CiQ" network="youtube" fgColor="#fff" style={{ marginLeft: '1em', height: 35, width: 35 }} />
                            <SocialIcon target="blank" url="https://linkedin.com/in/zippyops" network="linkedin" fgColor="#fff" style={{ marginLeft: '1em', height: 35, width: 35 }} />
                            <SocialIcon target="blank" url="https://t.me/ZippyOPS" network="telegram" fgColor="#fff" style={{ marginLeft: '1em', height: 35, width: 35 }}/>
              </div>
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="flex flex-wrap items-top mb-6">
                <div className="w-full lg:w-4/12 px-4 ml-auto">
                  <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">
                    Useful Links
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.zippyops.com/about-us"
                      >
                        About Us
                      </a>
                    </li>

                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.zippyops.com/services"
                      >
                        Services
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.zippyops.com/products"
                      >
                        Products
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.zippyops.com/contact-us"
                      >
                        Contact Us
                      </a>
                    </li>                    
                  </ul>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">
                  Blogs
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.zippyops.com/blog/infrastructure"
                      >
                        Infrastructure
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.zippyops.com/blog/devsecops"
                      >
                        DevSecOps
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.zippyops.com/blog/microservices"
                      >
                        Microservices
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.zippyops.com/blog/security"
                      >
                        Security
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <hr className="my-6 border-blueGray-300" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center">
              <div className="text-sm text-blueGray-500 font-semibold py-1">
                <a
                  href="https://www.zippyops.com"
                  className="text-blueGray-500 hover:text-blueGray-800"
                >
                  &copy;{" "}{1900 + new Date().getYear()}{" "}  ZippyOPS Consulting Services LLP
                </a>
                .
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
